/**
 * handleFailedItemRequest.js
 *
 * Copyright (c) apploft. GmbH
 */

import {ready} from '../ContentStateSymbol';
import {HTTPError} from 'apploft-cloud-client';

export default function handleFailedItemsRequest({error, section, api}) {
  if (error instanceof HTTPError) {
    const {status} = error;

    if (status === 404) {
      return {
        state: ready,
        data: {message: 'Sorry, this item does not exist.', section, api},
      };
    }
  }

  return {state: ready, data: error};
}
